import React from "react";
import styles from "./Banner.module.css";

const Banner = () => {
  return (
    <section className={styles.banner}>
      {/* 비디오 배경 */}
      <video className={styles.videoBackground} autoPlay loop muted playsInline>
        <source src="/videos/banner-bg.mp4" type="video/mp4" />
      </video>

      {/* 블루 필터 Overlay */}
      <div className={styles.overlay}></div>

      {/* 배너 콘텐츠 */}
      <div className={styles.content}>
        <h1 className={styles.title}>Invest in Your Future</h1>
        <p className={styles.subtitle}>
          The smarter way to trade stocks & grow your wealth.
        </p>
      </div>
    </section>
  );
};

export default Banner;
